import React from 'react'
import styled from 'styled-components'

// Layout and tokens mirror the feature's own NoResultsState so the two read as one family.
// No icon: the sibling NoResultsIcon hardcodes hex fills and would not theme in dark mode.
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 48px 16px;
  background: var(--color-surface);
  border: 1px solid var(--card-border-color);
  border-radius: var(--t-borders-radius-rounded-2xl);
  box-shadow: var(--shadow-1);
`

const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  max-width: 560px;
`

const Title = styled.div`
  font-size: var(--t-typography-font-size-base);
  color: var(--color-text);
  font-weight: var(--t-typography-font-weight-semi-bold);
  line-height: var(--t-typography-line-height-base);
  text-align: center;
`

const Description = styled.div`
  font-size: var(--t-typography-font-size-xs);
  color: var(--sub-text-color);
  font-weight: var(--t-typography-font-weight-medium);
  line-height: var(--t-typography-line-height-xs);
  text-align: center;
`

const State = ({ testId, title, description }) => (
  <Container data-testid={testId}>
    <TextGroup>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </TextGroup>
  </Container>
)

// Deliberately no CTA: the tenant's plan is changed by a CSM, not self-serve.
const NotEnabledState = ({ tenantName }) => (
  <State
    testId="Psima_NotEnabledState_div"
    title={`Phishing Simulation Agent isn't enabled for ${tenantName || 'this company'}.`}
    description="This agent runs reconnaissance-based simulations tailored to the threats your organization actually faces. Contact your Customer Success Manager to add it to your plan."
  />
)

// The API checks per-tenant access even when the partner can open the page.
export const AccessDeniedState = ({ tenantName }) => (
  <State
    testId="Psima_AccessDeniedState_div"
    title="Access denied"
    description={`You don't have permission to manage phishing simulations for ${
      tenantName || 'this company'
    }. Ask an administrator for campaign access, or pick a different company.`}
  />
)

// Omit the tenant name: selectActual* falls back to self when the selected row is missing.
export const TenantUnavailableState = () => (
  <State
    testId="Psima_TenantUnavailableState_div"
    title="We couldn't load this company"
    description="Pick it again from the company menu above, or refresh the page. If it keeps happening, contact support."
  />
)

export default NotEnabledState
